import type { IVisitsIndexProps } from '@on3/ui-lib/src/api/schema/custom-contracts';
import { InterestLegend } from 'components/College/Interests/General/InterestLegend';
import { VisitList } from 'components/College/Interests/Visits/VisitList';
import { RightSidebarLayout } from 'components/Layouts/RightSidebarLayout';
import { StandardSidebar } from 'components/Layouts/StandardSidebar';
import { Text } from 'components/UI/Typography/Text';

import { InterestListFilters } from '../General/InterestListFilters';
import styles from './VisitList.module.scss';

export const VisitsPage = ({
  visitsList,
  teams,
  years,
  sports,
  status,
  title,
}: IVisitsIndexProps) => {
  const { list, pagination } = visitsList || {};
  const visitList = list;

  return (
    <RightSidebarLayout>
      <div>
        <section>
          <header>
            <Text className={styles.pageTitle} variant="h1">
              {title}
            </Text>
          </header>
          <InterestListFilters
            selectedInterest="visits"
            sports={sports}
            status={status}
            teams={teams}
            years={years}
          />
        </section>
        <section>
          {visitList?.map((vlist, index) => {
            return (
              <VisitList
                key={`${pagination?.currentPage}-${pagination?.count}-${index}`}
                {...vlist}
              />
            );
          })}
          {!visitList?.length && (
            <Text className={styles.noListText}>
              There are no players for this selection.
            </Text>
          )}

          <InterestLegend />
        </section>
      </div>
      {/* When breakdown component comes, we will need custom sidebar. */}
      <StandardSidebar />
    </RightSidebarLayout>
  );
};
